import { message } from 'antd';
import * as Sentry from '@sentry/react';
import {
  createApiKeyClient,
  setupErrorInterceptor,
  type ProcessedError,
  type ApiErrorContext,
} from '@raporgor/api-client';
import { API_URL, API_KEY } from '../config';

// Create the API client with API Key auth
export const apiClient = createApiKeyClient(API_URL, API_KEY);

// Add custom error interceptor for UI notifications
setupErrorInterceptor(apiClient, {
  onError: (error: ProcessedError) => {
    // Show toast notification for errors
    if (error.severity === 'error') {
      message.error(error.message);
    } else if (error.severity === 'warning') {
      message.warning(error.message);
    }
  },
  reportToSentry: (axiosError, context?: ApiErrorContext) => {
    Sentry.captureException(axiosError, {
      extra: context ? { ...context } : undefined,
    });
  },
});
